import React                              from 'react';
import { Navigate, Route, Routes }        from 'react-router-dom';
import { EAppRoutes }                     from '../../../shared/constants/constants';
import { Authorized, EFamilyAccountType } from '../../../shared/utils/withAuthorization/withAuthorization';
import { AddMembers }                     from './AddMembers';

export const AddMembersRoutes = () => (
  <Routes>
    <Route
      path="/"
      element={<Navigate replace to="by-invite" />}
    />

    <Route
      path="/:tab?"
      element={
        <Authorized
          redirect={EAppRoutes.Dashboard}
          accountTypes={[ EFamilyAccountType.SuperAdmin ]}
        >
          <AddMembers />
        </Authorized>
      }
    />
  </Routes>
);
